export const ERROR_CURRENCY =
  'Invalid currency format. Enter a positive number with up to two decimal places.';
export const ERROR_GREATER_THAN_ZERO =
  'Value must be greater than or equal to 0';
export const ERROR_REQUIRED = 'A value is required';
export const ERROR_NUMBER = 'The value input must be a number';
export const ERROR_INTEGER = 'The value input must be a whole number';

export const FormValidations = {
  ERROR_CURRENCY,
  ERROR_GREATER_THAN_ZERO,
  ERROR_REQUIRED,
  ERROR_NUMBER,
  ERROR_INTEGER,
};
